import React, { useEffect, useRef, useState } from 'react';
import './activity-logs.styles.scss';
import { off } from 'firebase/database';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { getActivityLogsFromDb } from '@/utils/getDataFromDb';

const AdminActivityLogs = ({
    users,
    activityLogs
}) => {

    const [ toDisplay, setToDisplay ] = useState(null);
    const [ filterData, setFilterData ] = useState({})
    const activityRef = useRef();
    const filterDataRef = useRef();
    let logListener;

    useEffect(() => {

        return () => {
            if (logListener) logListener();
        }
	}, [])

    useEffect(() => {
        if (!activityLogs) return;
        setToDisplay(activityLogs);
    }, [activityLogs])

    // async function getRecentLogs() {
    //     getActivityLogs({'callback': callback, 'receiveListener': receiveListener})
    //     function callback(data) {
    //         // console.log(data);
    //         activityRef.current = {...activityRef.current, ...{[data.ts]: data}}
    //         setActivity(activityRef.current)
    //         setToDisplay(activityRef.current)
    //     }
    //     function receiveListener(unsubscribe) {
    //         logListener = unsubscribe;
    //     }
    // }

    

    function saveFilterData(key, value) {
        filterDataRef.current = {...filterDataRef.current, ...{[key]: value}}
        setFilterData(filterDataRef.current);
    }

    async function filterLogs() {
        setToDisplay({});
        const filterObj = {...{'callback': callback, 'handleListener': handleListener}, ...filterData}
        getActivityLogsFromDb(filterObj)
        function callback(data) {
            activityRef.current = {...activityRef.current, ...{[data.ts]: data}}
            setToDisplay(activityRef.current)
        }
        function handleListener(unsubscribe) {
            logListener = unsubscribe;
        }
    }

    return (
        <div className='activity-logs'>
            <div className='section-title'>
                <span>Activity Logs</span>
            </div>
            <div className="g-space-20"></div>
            <div className="filter-row">
                <div className='field'>
                    <select className='small' onChange={(e) => saveFilterData('cst_key', e.target.value)}>
                        <option value=''>Choose a user</option>
                        {
                            (users) &&
                            Object.values(users).sort((a, b) => (a.lName > b.lName) ? 1 : (a.lName === b.lName) ? ((a.fName > b.fName) ? 1 : -1) : -1 )
                            .map(user => (
                                <option key={user.cst_key} value={user.cst_key}>{user.lName}, {user.fName}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="field">
                    <select className='small' onChange={(e) => saveFilterData('type', e.target.value)}>
                        <option value=''>Choose a log type</option>
                        <option value='error'>Error</option>
                        <option value='success'>Success</option>
                    </select>
                </div>

                <button className='g-button small-btn primary' onClick={() => filterLogs()}>Filter Results<FontAwesomeIcon icon={faFilter} /></button>
            </div>
            <table className='g-table logs-table'>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Type</th>
                        <th>Function</th>
                        <th>Message</th>
                        <th>Data</th>
                    </tr>
                </thead>
                <tbody>
                {
                    (toDisplay && users) && 
                    Object.values(toDisplay).sort((a,b) => a.ts < b.ts ? 1 : -1)
                    .map(a => {
                        return (
                        <tr key={a.ts}>
                            <td>{format(new Date(a.ts), 'Pp')}</td>
                            <td>{users[a.user] ? `${users[a.user].fName} ${users[a.user].lName}` : a.user}</td>
                            <td>{a.type}</td>
                            <td>{a.functName}</td>
                            <td>{a.message ?? a.action}</td>
                            <td>{
                                (a.data && typeof a.data === 'object') 
                                ? 
                                Object.keys(a.data).map(k => (
                                    <div key={k}>
                                        <span>
                                            <b>{k}: </b>{a.data[k].toString()}
                                        </span><br />
                                    </div>
                                ))
                                : 
                                a.data ?? null}</td>
                        </tr>
                    )})
                      
                }
                </tbody>
            </table>
        </div>
    )
}

export default AdminActivityLogs;